import script from "./parkingOrderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./parkingOrderDetail.vue?vue&type=script&setup=true&lang=js"

import "./parkingOrderDetail.vue?vue&type=style&index=0&id=2da6de98&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da6de98"]])

export default __exports__